import React, {Component} from 'react'
import moment from 'moment'
import styles from '../../containers/Desk/counselling/all/styles.less'

class LatestRawFollowup extends Component {

    renderStatus = (val) => {

        if (val === 'Fit2Apply' || val === 'Didn\'t Pick up Call') {
            return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>
        }

        if (val === 'Luke Warm' || val === 'Out Of town') {
            return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>
        }

        if (val === 'Potential' || val === 'Not Interested') {
            return <div className={styles.Potential}>{val.toUpperCase()}</div>
        }
        
        if (val === 'B2B') {
            return <div className={styles.Potential}>{val.toUpperCase()}</div>
        }
        if (val === 'Dead') {
            return <div className={styles.dead}>{val.toUpperCase()}</div>
        }

        if (val === 'Dead' || val === 'Busy, Call Later') {
            return <div className={styles.dead}>{val.toUpperCase()}</div>
        }

        if (val === 'Cold' || val === 'Active') {
            return <div className={styles.Cold}>{val.toUpperCase()}</div>
        }
    }

    render() {
        let {info} = this.props
        return (
            <div>
                <b>{info ? info.detail : ''}</b>
                <div>{info ? this.renderStatus(info.followUpType) : ''}</div>
                <div>
                    <small>
                        {info && info.createdByUser ? `${info.createdByUser.name + '   '}` : ''}<br/>
                        {info ? moment(info.followUpDate).format('lll') : ''}
                    </small>
                </div>
            </div>
        )
    }
}

export default LatestRawFollowup
